import React from "react";

const ArrowRight = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M2 12h20M15 5l7 7-7 7" />
    </g>
  </svg>
);

export default ArrowRight;



// WEBPACK FOOTER //
// ./src/theme/icons/ArrowRight.js